import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/MenuSection.css";
import apiUrl from "../config"; // ✅ You already use this pattern elsewhere

export default function MenuSection() {
    const [menuData, setMenuData]               = useState([]);
    const [activeCategory, setActiveCategory]   = useState("");
    const [activeSubcategory, setActiveSubcategory] = useState("");

    useEffect(() => {
        axios
            .get(`${apiUrl}/api/menu`)
            .then(({ data }) => {
                setMenuData(data);
                if (data.length) setActiveCategory(data[0].category);
            })
            .catch(console.error);
    }, []);

    // 1️⃣ Filter items in the chosen category
    const selected = menuData.filter(i => i.category === activeCategory);

    // 2️⃣ What subcategories exist here?
    const subcats = [
        ...new Set(selected.map(i => i.subcategory).filter(Boolean))
    ];

    // 3️⃣ Auto-pick defaults:
    useEffect(() => {
        if (activeCategory === "Drinks")  setActiveSubcategory("Hot Drinks");
        if (activeCategory === "Bottles") setActiveSubcategory("Tequila");
    }, [activeCategory]);

    // 4️⃣ Items to render IN GRID when not Shots
    //    (if no subcategory selected, show *all* real items)
    const nonShotItems = activeSubcategory
        ? selected.filter(i => i.subcategory === activeSubcategory)
        : selected.filter(i => !i.groupTitle);

    // 5️⃣ Shots grouping
    const isShots    = activeSubcategory === "Shots";
    const shotItems  = selected.filter(i => i.subcategory === "Shots" && i.name);
    const shotGroups = [...new Set(shotItems.map(i => i.groupTitle))];

    return (
        <div className="menu-section">
            {/* Hero */}
            <div className="menu-hero">
                <h1 className="menu-title">Our Menu</h1>
            </div>

            {/* Category buttons */}
            <div className="menu-categories">
                {[...new Set(menuData.map(i => i.category))].map(cat => (
                    <button
                        key={cat}
                        className={`category-button ${
                            cat === activeCategory ? "active" : ""
                        }`}
                        onClick={() => {
                            setActiveCategory(cat);
                            setActiveSubcategory("");
                        }}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            {/* Subcategory buttons */}
            {subcats.length > 0 && (
                <div className="menu-subcategories">
                    {subcats.map(sub => (
                        <button
                            key={sub}
                            className={`subcategory-button ${
                                sub === activeSubcategory ? "active" : ""
                            }`}
                            onClick={() => setActiveSubcategory(sub)}
                        >
                            {sub}
                        </button>
                    ))}
                </div>
            )}

            {/* Items */}
            {isShots ? (
                // ─── Shots: grouped layout ─────────────────────────────
                shotGroups.map(groupTitle => (
                    <React.Fragment key={groupTitle}>
                        <div className="group-title-container">
                            <h2 className="group-title">{groupTitle}</h2>
                        </div>
                        <div className="shots-grid">
                            {shotItems
                                .filter(item => item.groupTitle === groupTitle)
                                .map(item => (
                                    <div key={item._id} className="menu-item">
                                        <div className="item-info">
                                            <h3>{item.name}</h3>
                                            <p>{item.description}</p>
                                        </div>
                                        <div className="item-price">${item.price}</div>
                                    </div>
                                ))}
                        </div>
                    </React.Fragment>
                ))
            ) : (
                // ─── Everything else: simple two-column grid ────────────
                <div className="menu-items">
                    {nonShotItems.map(item => (
                        <div key={item._id} className="menu-item">
                            <div className="item-info">
                                <h3>{item.name}</h3>
                                <p>{item.description}</p>
                            </div>
                            <div className="item-price">${item.price}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
